import React from "react";
import ProgressBar from "./ProgressBarItem";

interface ProgressBarItem {
  label?: string;
  actual: number;
  total: number;
  actualGradientColor?: string;
  height?: number;
}

interface ProgressBarGroupProps {
  title?: string;
  items: ProgressBarItem[];
}

const ProgressBarGroup: React.FC<ProgressBarGroupProps> = ({
  title,
  items,
}) => {
  const groupTitle = title || "";
  const groupItems = items || [];

  return (
    <div
      className={`
        col-span-6 
        px-4
        overflow-hidden
        flex
        flex-col
      `}
    >
      {groupTitle && (
        <div className="mb-1">
          <label className="text-sm font-medium text-gray-700">
            {groupTitle}
          </label>
        </div>
      )}

      <div className="flex-grow flex flex-col">
        {groupItems.map((item, index) => (
          <ProgressBar
            key={index}
            label={item.label || ""}
            actual={item.actual}
            total={item.total}
            actualGradientColor={item.actualGradientColor}
            height={item.height}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBarGroup;
